<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-29 13:42:22
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-29 13:44:21
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/myActivities/list/components/tableCell/goodsCountCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="fz-12">已报名：{{ row.apply_item_count }}</div>
		<div class="fz-12"
			>待审核：<span
				:class="row.wait_audit_item_count > 0 ? 'pointer yx-color-primary' : ''"
				@click="goToDetail(row.activity_id, row.third_activity_id)"
				>{{ row.wait_audit_item_count }}</span
			></div
		>
		<div class="fz-12">审核通过：{{ row.audit_ass_item_count }}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	components: {},
	data() {
		return {};
	},
	methods: {
		goToDetail(id, third_activity_id) {
			if (!this.$auth.hasPermi('system:myActivities-detail:query')) {
				return;
			}
			const { platformId: platform_id } = this;
			this.$router.push({
				path: '/secondColonelManage/myActivities/detail',
				query: { id, third_activity_id, platform_id, authority_id: this.authorityId },
			});
		},
	},
};
</script>
